// extracted by mini-css-extract-plugin
export var form = "_4y-0";